import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import HttpClient from './../../services/HttpClient';
import { getUserToken } from '../../services/utils';
import { getBaseNewURL, getBaseURL } from '../../services/getBaseURL';

const http = new HttpClient();
const baseUrlcustomize = `${getBaseURL().customize}`;
const baseUrl = `${getBaseNewURL().base}`;

const initialState = {
	isOpenSheet: false,
	transactionID: null,
	transactionData: [],
	isLoading: {
		backdrop: false,
		form: false,
		topCardSkeleton: false,
		listSkeleton: false,
		button: false,
		pageSpinner: false,
		skeleton: false,
	},
	paymentLoading: false,
	error: '',
	customError: null,
	debts: [],
	currentDebt: {},
	errorMassege: null,
	transactionPropsData: [],
	detailInstallments: [],
	paymentURL: '',
	debtDetails: {},
	transactionItem: {},
};

export const PostTransaction = createAsyncThunk('/transactions', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {};
	const response = await http.post(`${baseUrl}/GetTransactions`, param, extraConfig).then((res) => res.data);
	return response;
});

export const getTransactionDetails = createAsyncThunk('/getTransactionDetails', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {
		Id: params?.transactionId,
	};
	const response = await http
		.post(`${baseUrl}/GetTransactionDetails`, param, extraConfig)
		.then((res) => res.data);
	return response;
});

export const GetCurrentDebt = createAsyncThunk('/currentDebt', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {
		'sponsorId': params?.sponsorId,
	};
	const response = await http.post(`${baseUrl}/GetCurrentDebt`, param, extraConfig).then((res) => res.data);
	return response;
});

export const GetDebtsList = createAsyncThunk('/debts', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {
		'year': params?.year,
		'sponsorId': params?.sponsorId,
	};
	const response = await http.post(`${baseUrl}/GetDebtsList`, param, extraConfig).then((res) => res.data);
	return response;
});

export const GetDebtDetails = createAsyncThunk('/debtDetails', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {
		'sponsorId': params?.sponosorId,
		'startDate': params?.startDate,
		'endDate': params?.endDate,
	};
	const response = await http.post(`${baseUrl}/GetDebtDetails`, param, extraConfig).then((res) => res.data);
	return response;
});

export const payOnline = createAsyncThunk('/payOnline', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {
		DebtNumber: params.debtNumber,
		'ReturnURL': params.returnUrl,
	};
	const response = await http
		.post(`${baseUrlcustomize}Installments/Pay`, param, extraConfig, params?.isToastfy)
		.then((res) => {
			return res.data;
		});
	return response;
});

const transactionSlice = createSlice({
	name: 'transaction',
	initialState,
	reducers: {
		changedSheetStatus(state, action) {
			state.isOpenSheet = true;
			state.transactionID = action.payload;
		},
		setData(state, action) {
			state.transactionPropsData = action.payload;
		},
		getdetailInstallments(state, action) {
			state.detailInstallments = action.payload;
		},
		resetCustomError(state) {
			state.customError = null;
		},
	},

	extraReducers: (builder) => {
		builder
			.addCase(PostTransaction.pending, (state) => {
				state.isLoading.pageSpinner = true;
			})
			.addCase(PostTransaction.fulfilled, (state, action) => {
				state.isLoading.pageSpinner = false;
				const { Success, Content, Message } = action.payload;
				if (Success) {
					const sortedTransactions = Content.Transactions?.sort(function (a, b) {
						return new Date(b.TransactionDate) - new Date(a.TransactionDate);
					});
					state.transactionData = sortedTransactions;
				} else {
					state.errorMassege = Message;
				}
			})
			.addCase(PostTransaction.rejected, (state) => {
				state.isLoading.pageSpinner = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(getTransactionDetails.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getTransactionDetails.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;

				if (Success) {
					state.transactionItem = Content;
				}

				state.isLoading.skeleton = false;
			})
			.addCase(getTransactionDetails.rejected, (state) => {
				state.isLoading.skeleton = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(payOnline.pending, (state) => {
				state.paymentLoading = true;
			})
			.addCase(payOnline.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.paymentURL = Content?.PaymentURL;
				}
				state.paymentLoading = false;
			})
			.addCase(payOnline.rejected, (state) => {
				state.paymentLoading = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(GetCurrentDebt.pending, (state) => {
				state.isLoading.topCardSkeleton = true;
			})
			.addCase(GetCurrentDebt.fulfilled, (state, action) => {
				const { Success, Content, Status, Message } = action.payload;
				if (Success) {
					state.currentDebt = Content;
				}
				state.isLoading.topCardSkeleton = false;

				if (Status === 645 && state.customError !== null) {
					state.customError = Message;
				}
			})
			.addCase(GetCurrentDebt.rejected, (state) => {
				state.isLoading.topCardSkeleton = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(GetDebtsList.pending, (state) => {
				state.isLoading.listSkeleton = true;
			})
			.addCase(GetDebtsList.fulfilled, (state, action) => {
				const { Success, Content, Status, Message } = action.payload;
				if (Success) {
					state.debts = Content?.Items;
				}
				state.isLoading.listSkeleton = false;

				if (Status === 645) {
					state.customError = Message;
				}
			})
			.addCase(GetDebtsList.rejected, (state) => {
				state.isLoading.listSkeleton = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(GetDebtDetails.pending, (state) => {
				state.isLoading.topCardSkeleton = true;
			})
			.addCase(GetDebtDetails.fulfilled, (state, action) => {
				const { Success, Content, Status, Message } = action.payload;
				if (Success) {
					state.debtDetails = Content;
				}
				state.isLoading.topCardSkeleton = false;

				if (Status === 645) {
					state.customError = Message;
				}
			})
			.addCase(GetDebtDetails.rejected, (state) => {
				state.isLoading.topCardSkeleton = false;
				state.error = 'خطا در بر قراری سرور';
			});
	},
});

export const { changedSheetStatus, setData, getdetailInstallments, resetCustomError } =
	transactionSlice.actions;
export default transactionSlice.reducer;
